import { Component } from "react";
import type { ErrorInfo, ReactNode } from "react";
import errorMonitoring from "./errorMonitoring";

interface ErrorMonitoringErrorBoundaryProps {
  action: string;
  children: ReactNode;
  fallback?: (error: Error) => ReactNode;
}

interface ErrorMonitoringErrorBoundaryState {
  error?: Error;
}

class ErrorMonitoringErrorBoundary extends Component<
  ErrorMonitoringErrorBoundaryProps,
  ErrorMonitoringErrorBoundaryState
> {
  state: ErrorMonitoringErrorBoundaryState = { error: undefined };

  static getDerivedStateFromError(
    error: Error
  ): ErrorMonitoringErrorBoundaryState {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    errorMonitoring.sendError(error, span => {
      span.setAction(this.props.action);
      span.setTags({
        framework: "React",
        componentStack: errorInfo.componentStack || ""
      });
    });
  }

  render() {
    if (this.state.error) {
      return this.props.fallback ? this.props.fallback(this.state.error) : null;
    }

    return this.props.children;
  }
}

export default ErrorMonitoringErrorBoundary;
